import Config from "src/Constants/Config";

import setCurrentPage from "src/Utils/setCurrentPage";

import { Audios, Animation } from "@yamildiego/presentation-kit";

import store from "src/Reducers/store";
import { useSelector } from "react-redux";

const DATA_CHAT = () => {
  const PageId = 115;
  const PreviousPageId = PageId - 1;
  const NextPageId = PageId + 1;

  const path = "/images/death_claim/chat_15/chat_";

  const DATA_IMAGES = [
    { image: `${Config.BASE_URL}${path}0.png`, imageStyle: { position: "static", width: "100%" } },
    { image: `${Config.BASE_URL}${path}1.png`, imageStyle: { position: "static", width: "100%" } },
  ];

  const pathAudios = `${Config.BASE_URL}/audios/death_claim/`;

  const AUDIOS = [
    { src: `${pathAudios}PRCX_18_Death Claim - Scene 14 - Franky 1 - v1.mp3`, timer: 100 },
    { src: `${pathAudios}PRCX_18_Death Claim - Scene 14 - Senior Lady 1 - v1.mp3`, timer: 3100 },
  ];

  const times = [600, 3200];

  const currentPage = useSelector(() => store.getState().appReducer.currentPage);
  const muted = useSelector(() => store.getState().appReducer.muted);

  return {
    bgImage: `${Config.BASE_URL}/images/death_claim/bg_opacity_15.png`,
    rightSideImage: {
      image: `${Config.BASE_URL}/images/death_claim/man_chat.png`,
      style: { width: "52.6875rem", display: "flex", height: "100%" },
    },
    leftSideImage: {
      image: `${Config.BASE_URL}/images/death_claim/OlderWoman_chat.png`,
      style: { width: "25rem", display: "flex", height: "100%" },
    },
    back: { type: "back", startIcon: "arrow-left", onClick: () => setCurrentPage(PreviousPageId) },
    next: { type: "next", endIcon: "arrow-right", onClick: () => setCurrentPage(NextPageId) },
    chatImages: <Animation times={times} pageNumber={PageId} currentPage={currentPage} images={DATA_IMAGES} />,
    audio: <Audios muted={muted} pageNumber={PageId} currentPage={currentPage} audios={AUDIOS} />,
  };
};

export default DATA_CHAT;
